import { useDataValue, useDataSubmit } from 'Simple/Data.js'
import { isSameDay } from 'date-fns'

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data) {
  let submitTab = useDataSubmit({
    viewPath: props.viewPath,
    context: 'tab',
  })
  let tabDate = useDataValue({
    context: 'tab',
    path: 'selected.date',
    viewPath: props.viewPath,
  })

  return async function onSubmit({ args }) {
    if (typeof props.closePopover === 'function') props.closePopover()
    if (isSameDay(args.date, tabDate)) return
    submitTab({
      type: 'setDate',
      date: args.date,
    })
  }
}
